"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var DocumentComponent = /** @class */ (function () {
    function DocumentComponent() {
        this.documentPreviewEnabled = true;
        this.showUploadDate = true;
        this.showDocumentSize = true;
        this.showUploadedBy = true;
        this.onDocumentUpload = new core_1.EventEmitter();
        this.onDocumentRemove = new core_1.EventEmitter();
        this.onMetaDataUpdate = new core_1.EventEmitter();
        this.metaData = null;
    }
    Object.defineProperty(DocumentComponent.prototype, "entity", {
        set: function (entity) {
            this._entityId = entity ? (entity.getInstanceId() != undefined ? entity.getInstanceId() : entity.getId()) : null;
            this._entityId = this._entityId || -1;
        },
        enumerable: true,
        configurable: true
    });
    DocumentComponent.prototype.ngOnInit = function () {
    };
    DocumentComponent.prototype.onUpload = function (value) {
        this.onDocumentUpload.emit(value);
    };
    DocumentComponent.prototype.onRemove = function (value) {
        this.onDocumentRemove.emit(value);
    };
    Object.defineProperty(DocumentComponent.prototype, "entityId", {
        get: function () {
            return this._entityId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentComponent.prototype, "previewEnabled", {
        get: function () {
            return String(this.documentPreviewEnabled) === '' ? true : this.documentPreviewEnabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentComponent.prototype, "showDate", {
        get: function () {
            return String(this.showUploadDate) === '' ? true : this.showUploadDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentComponent.prototype, "showSize", {
        get: function () {
            return String(this.showDocumentSize) === '' ? true : this.showDocumentSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentComponent.prototype, "showUser", {
        get: function () {
            return String(this.showUploadedBy) === '' ? true : this.showUploadedBy;
        },
        enumerable: true,
        configurable: true
    });
    DocumentComponent.prototype.metaDataUpdated = function (value) {
        this.onMetaDataUpdate.emit(value);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DocumentComponent.prototype, "documentId", void 0);
    __decorate([
        core_1.Input('entity'),
        __metadata("design:type", idm_de_core_frontend_1.Entity),
        __metadata("design:paramtypes", [idm_de_core_frontend_1.Entity])
    ], DocumentComponent.prototype, "entity", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentComponent.prototype, "documentRootName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DocumentComponent.prototype, "filePolicy", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DocumentComponent.prototype, "height", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentComponent.prototype, "documentPreviewEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentComponent.prototype, "showUploadDate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentComponent.prototype, "showDocumentSize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentComponent.prototype, "showUploadedBy", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DocumentComponent.prototype, "onDocumentUpload", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DocumentComponent.prototype, "onDocumentRemove", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], DocumentComponent.prototype, "onMetaDataUpdate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Map)
    ], DocumentComponent.prototype, "metaData", void 0);
    DocumentComponent = __decorate([
        core_1.Component({
            
            selector: "sis-document",
            template: require('./sis-document.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "\n        <sis-document\n                    [isReadonly]=\"%{isReadonly}\"\n                    [documentId]=\"%{field}\"\n                    [entity]=\"entity\"\n                    [category]=\"category\"\n                    [documentRootName]=\"%{documentRootName}? %{documentRootName}: '%{field-name}'\"\n                    [filePolicy]=\"%{filePolicy}\"\n                    [id]=\"%{id}\"\n                    [height]=\"%{height}\"\n                    [documentPreviewEnabled]=\"%{documentPreviewEnabled}\"\n                    [showUploadDate]=\"%{showUploadDate}\"\n                    [showDocumentSize]=\"%{showDocumentSize}\"\n                    [showUploadedBy]=\"%{showUploadedBy}\"\n                    (onDocumentUpload)=\"%{onDocumentUpload}\"\n                    (onDocumentRemove)=\"%{onDocumentRemove}\">\n        </sis-document>",
            iconInfo: "fa-caret-square-o-down",
            name: "DocumentComponent",
            defaultActions: {
                'onDocumentUpload': 'submitDocument',
                'onDocumentRemove': 'removeDocument'
            }
        }),
        __metadata("design:paramtypes", [])
    ], DocumentComponent);
    return DocumentComponent;
}());
exports.DocumentComponent = DocumentComponent;
//# sourceMappingURL=sis-document.component.js.map